import * as React from 'react';

import { WebsiteLogger } from '@prezi/client-logger-module';

import { CategoryData } from '../App';
import { CATEGORY_ALL_SLUG, PreziData } from './App';
import { CategoryHeader } from '../components/CategoryHeader';
import { CategorySidebar } from '../components/CategorySidebar';
import { CategoryPulldown } from '../components/CategoryPulldown';
import { MetaTags } from '../components/Meta';
import { CategorySidebarWrapper } from '../styles/CategoryPage';
import { PreziCard } from './PreziCard/PreziCard';

declare const Site: any;

const gray1 = "#152235";

export interface CategoryPageProps {
    currentCategory: CategoryData;
    categories: Array<CategoryData>;
    prezis: Array<PreziData>;
    basePath: string;
    categoryString: string;
    headerColor?: string;
    activeGalleryTab?: string;
    presentationsTabString?: string;
    videosTabString?: string;
    designTabString?: string;
    isUseAsTemplateFlowActive?: boolean;
    templateFlowPageTitleString?: string;
}

export default class CategoryPage extends React.Component<CategoryPageProps, any> {
    headerColor: string

    constructor(props: CategoryPageProps) {
        super(props);
        this.headerColor = props.headerColor || gray1;
        document.body.style.backgroundColor = this.headerColor;
    }

    getCanonicalUrl(): string {
        const slug = this.props.currentCategory.slug;
        return slug === CATEGORY_ALL_SLUG ? this.props.basePath : `${this.props.basePath}${slug}/`;
    }

    getRelatedPrezis(prezis: Array<PreziData>, currentCategory: CategoryData): Array<PreziData> {
        if (currentCategory.slug === CATEGORY_ALL_SLUG) {
            return prezis;
        } else {
            return prezis.filter(prezi =>
                prezi.categories.indexOf(currentCategory.slug) !== -1,
            );
        }
    }

    logCategoryView = function() {
        WebsiteLogger.log({
            action: 'view',
            object: 'logged_element',
            trigger: 'view',
            payload: {element_text: this.props.currentCategory.slug,
                element_type: 'gallery_category_page',
                source_url: window.location.pathname,
                user_id: Site.user_id},
        });
    };

    componentDidMount() {
        this.logCategoryView();
    }

    componentDidUpdate() {
        this.logCategoryView();
    }

    render() {
        return this.props.currentCategory ? (
            <div>
                <MetaTags
                    title={ this.props.currentCategory.page_title }
                    description={ this.props.currentCategory.meta_description }
                    slug={ this.props.currentCategory.slug }
                    canonicalUrl={ this.getCanonicalUrl() }
                />
                <CategoryHeader
                    category={ this.props.currentCategory }
                    headerColor={this.headerColor}
                    activeGalleryTab={this.props.activeGalleryTab}
                    presentationsTabString={this.props.presentationsTabString}
                    videosTabString={this.props.videosTabString}
                    designTabString={this.props.designTabString}
                    isUseAsTemplateFlowActive={this.props.isUseAsTemplateFlowActive}
                    templateFlowPageTitleString={this.props.templateFlowPageTitleString}
                />
                <CategorySidebarWrapper className={ 'section' }>
                    <div className={ 'container' }>
                        <div className={ 'row' }>
                            <div className={ 'col-lg-2 visible-lg' }>
                                <CategorySidebar
                                    categories={ this.props.categories }
                                    basePath={ this.props.basePath }
                                    currentCategory={ this.props.currentCategory }
                                    categoryString={ this.props.categoryString }
                                />
                            </div>
                            <div className={ 'container visible-md visible-sm visible-xs' }>
                                <CategoryPulldown
                                    categories={ this.props.categories }
                                    basePath={ this.props.basePath }
                                    currentCategory={ this.props.currentCategory }
                                />
                            </div>
                            <div className={ 'col-xs-12 col-lg-10 pad-zero' }>
                                { this.getRelatedPrezis(this.props.prezis, this.props.currentCategory).map(prezi => (
                                    <PreziCard key={ prezi.oid } prezi={ prezi } />
                                )) }
                            </div>
                        </div>
                    </div>
                </CategorySidebarWrapper>
            </div>
        ): null;
    }
}



// WEBPACK FOOTER //
// ./assets/js/GalleryPage/CategoryPage2.tsx